import { Skeleton } from '@material-ui/lab';

import { useStyles } from './useStyles';

export const CsvUploadSkeleton = () => {
  const styles = useStyles();

  return (
    <div className={styles.container}>
      <Skeleton
        variant="text"
        className={styles.skeletonRect}
        width={'50%'}
        animation="wave"
      />
      <Skeleton
        variant="text"
        className={styles.skeletonRect}
        width={'20%'}
        animation="wave"
      />
    </div>
  );
};
